module.exports = __webpack_public_path__ + "static/scale-model-of-virginia-beach-virginia-f2f69b3794a45a627f5b2b7cc0ceec9c.png";